// 审核状态(代码位)
export const codeListStatus = [
	{ label: '待审核', value: 0 },
	{ label: '通过', value: 1 },
	{ label: '未通过', value: 2 },
];

// 竞价类型
export const BiddingTypes = [
  {
    value: 1,
    label: '客户端竞价',
  },
  {
    value: 2,
    label: '固定CPM',
  },
];

// 竞价类型（含服务端竞价，union账户权限 server_bid_auth = 1）
export const BiddingTypes2 = [
	{
		value: 1,
		label: '客户端竞价',
	},
	{
		value: 2,
		label: '固定CPM',
	},
	{
		value: 3,
		label: '服务端竞价',
	}
];
  // "video_sound":"319",                //视频声音控制(功能号) 319:有声音功能号
  // "video_auto_play":"",           //视频自动播放(功能号) 309:自动播放功能号
  // "creative_type_id":1,           //创意样式id
  // "shake_num":"904827",                   //摇一摇(功能号)       904827:摇一摇功能号
  // "open_screen_skip_button_num":"972659",//开屏-跳过按钮(功能号) 972659:不跳过功能号
  // "motivate_video_skip_num":1,    //激励视频-几秒可以跳过(功能号) 972659:不跳过功能号
  // "insert_screen_skip_button":1,  //几秒显示跳过按钮
  // "screen_ori":1,                 //屏幕方向 1:竖板
  // "reward_opt":1,                 //奖励发放设置 1:无需服务端确认

export const AccAdtypesImage = [
  {
    value: 2,
    label: '图文',
  },
];
export const AccAdtypesVideo = [
  {
    value: 3,
    label: '激励视频',
  },
];
// 创意类型
export const AccAdtypes = [
  {
    value: 1,
    label: '图文+视频',
  },
  ...AccAdtypesImage,
  {
    value: 3,
    label: '视频',
  },
];

// 渲染类型
export const RenderMethod = [
  {
    value: 1,
    label: '模板渲染',
  },
  {
    value: 2,
    label: '自渲染',
  },
];
export const RenderEnum = {
  TEMPLATE: 1,
  SELF: 2
}

// 渲染方式
export const RenderMethodModule = [
  {
    value: 1,
    label: '模板渲染',
  }
];
// 渲染方式（含自渲染，union账户权限 self_render_auth = 1）
export const RenderMethodModule2 = [
	{
		value: 1,
		label: '模板渲染',
	},
	{
		value: 2,
		label: '自渲染',
	}
];

// 自定义渲染：1图文 2大图 3组图 4视频 11竖板视频
export const StyleCustoms = [
  {
    value: 1,
    label: '图文',
    image: '/images/icon_image.png',
    hidden: 3 // 根据创意类型隐藏
  },
  {
    value: 2,
    label: '大图',
    image: '/images/icon_big_image.png',
    hidden: 3 // 根据创意类型隐藏
  },
  {
    value: 3,
    label: '组图',
    image: '/images/icon_images.png',
    hidden: 3 // 根据创意类型隐藏
  },
  {
    value: 4,
    label: '视频',
    image: '/images/icon_video.png',
    hidden: 2 // 根据创意类型隐藏
  },
  {
    value: 11,
    label: '竖板视频',
    image: '/images/icon_video_v.png',
    hidden: 2 // 根据创意类型隐藏
  },
]

export const VideoSound = [
  {
    value: "",
    label: '静音',
  },
  {
    value: 316,
    label: '有声',
  },
]
//309:自动播放功能号    2:wifi  325:不自动
export const VideoAutoPlay = [
  {
    value: 309,
    label: '自动播放',
  },
  {
    value: '',
    label: 'wifi下自动播放',
  },
  {
    value: 325,
    label: '不自动播放',
  },
]
export const ScreenOri = [
  {
    value: 1,
    label: '竖版',
  },
  {
    value: 2,
    label: '横版',
  },
]
export const NewScreenOri = [
	{
		value: 1,
		label: '竖版',
	}
]
// 跳过按钮是否展示-开屏
export const SkipShow = [
  {
    value: "",
    label: '显示',
  },
  {
    value: "636954",
    label: '不显示',
  },
];
// 跳过按钮
export const SkipOptions = [
  // {
  //   value: "972659",
  //   label: '不跳过',
  // },
  {
    value: "",
    label: '跳过',
  },
];
// 互动类型
export const ShakeTypes = [
  {
    value: "904827",
    label: '摇一摇',
  },
  {
    value: "901611",
    label: '滑一滑',
  },
  {
    value: "nyn",
    label: '扭一扭',
  },
];
// 奖励发放设置
export const RewardOptions = [
  {
    value: 1,
    label: '无需服务端确认',
  },
]